import PropTypes from "prop-types";
import QuotationTransferItem from "./QuotationTransferItem";
import "./QuotationTransfers.scss";

const QuotationTransfers = ({ transfers, onChange }) => {
	const [firstTransfer] = transfers;
	const isFirstTransferIncluded = firstTransfer.included;

	return (
		<div className="quotation-transfers">
			{transfers.map((transfer, index) => {
				return (
					<QuotationTransferItem
						key={transfer.code}
						isFirstTransferIncluded={isFirstTransferIncluded}
						defaultToNoTransfer={!isFirstTransferIncluded && index === 0}
						indexInArray={index}
						transfer={transfer}
						onChange={onChange}
					/>
				);
			})}
		</div>
	);
};

QuotationTransfers.propTypes = {
	transfers: PropTypes.array,
	onChange: PropTypes.func,
};

QuotationTransfers.defaultProps = {
	transfers: [],
	field: {},
};

export default QuotationTransfers;
